<template>
    <div class="shadow" v-if="isShow" @click="isShow = false">
        <div class="minutes-detail" @click.stop>
            <div class="title">
                洗衣費用
            </div>
            <div class="note">
                <div>服務費用： 一袋400元</div>
                <div>洗衣費用： 實報實銷</div>
                <div>僅提供一般水洗服務</div>
            </div>
            <div class="tip">
                不提供乾洗，衣物熨燙<br/>
                精緻衣物、不可烘乾、易縮水材質請勿送洗
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'WashPriceDetail',
        data() {
            return {
                isShow: false,
            }
        },
        methods: {
            show() {
                this.isShow = true;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .shadow {
        z-index: 20;
        position: absolute !important;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 100%;
    }

    .minutes-detail {
        border-radius: 6px;
        background-color: rgba(255,255,255,1);
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        padding: 15px;
        position: absolute;
        bottom: 65px;
        right: 15px;
        left: 15px;
        text-align: left;
        color: #4A4A4A;
        font-size: 12px;

        .title {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
        }

        .note {
            margin-top: 20px;
            line-height: 20px;
        }

        .tip {
            margin-top: 10px;
            color: #F44336;
            line-height: 17px;
        }
    }
</style>
